function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBgActionbarBlack = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 105 50"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M-5927-102.8h-334.6v-51h266.4c2.9 0 13.3-.1 21.4 4.4s11.8 11.1 14.6 19.1c2.5 7.3 7.5 13.6 14 17.6 5.1 3.1 11 4.8 17 4.9h.5c6-.1 11.9-1.7 17-4.9 6.6-4.1 11.6-10.3 14-17.6 2.7-8 6.6-14.6 14.6-19.1s18.4-4.4 21.4-4.4h6.4v51z",
  style: {
    fill: "#000"
  },
  transform: "translate(5993 153.766)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-5927-102.8h-334.6v-51h266.4c2.9 0 13.3-.1 21.4 4.4s11.8 11.1 14.6 19.1c2.5 7.3 7.5 13.6 14 17.6 5.1 3.1 11 4.8 17 4.9h.5c6-.1 11.9-1.7 17-4.9 6.6-4.1 11.6-10.3 14-17.6 2.7-8 6.6-14.6 14.6-19.1s18.4-4.4 21.4-4.4h6.4v51z",
  style: {
    fill: "none"
  },
  transform: "translate(5993 153.766)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-5855.4-103.8v-49h-5.6c-1.4 0-4.8 0-8.7.6-4.7.7-8.7 1.9-11.9 3.7-3.7 2-6.6 4.6-9 7.9-2 2.8-3.7 6.2-5.2 10.6-1.3 3.9-3.3 7.5-5.9 10.7-2.4 2.9-5.3 5.5-8.5 7.4-2.9 1.7-6 3.1-9.2 3.9-2.7.7-5.5 1.1-8.3 1.1h-.5c-2.8 0-5.6-.4-8.3-1.1-3.2-.8-6.3-2.1-9.2-3.9-3.2-2-6.1-4.5-8.5-7.4-2.6-3.2-4.6-6.8-6-10.7-1.5-4.4-3.2-7.8-5.2-10.6-2.4-3.3-5.3-5.9-9-7.9-3.2-1.8-7.2-3.1-11.9-3.7-3.9-.6-7.3-.6-8.7-.6h-265.6v49zm1 1h-407.3v-51h266.6c3.3 0 13.3.1 21.1 4.4 8 4.5 11.8 11.1 14.6 19.1s8 13.9 14 17.6c5.9 3.6 12.2 4.8 17 4.9h.5c4.8-.1 11-1.2 17-4.9 6.1-3.7 11.3-9.7 14-17.6 2.7-8 6.6-14.6 14.6-19.1 7.8-4.4 17.9-4.4 21.1-4.4h6.6z",
  style: {
    fill: "#000"
  },
  transform: "translate(5993 153.766)"
}));
export default SvgBgActionbarBlack;